export const tutorial: Record<string, string> = {
	tutorial_1_1: "Mova-se com estas teclas:",
	tutorial_1_2: "Também pode usar teclado numerico ou setas.",
	tutorial_1_4: "<- Vá para as escadas",
	tutorial_2_1: "<-A porta está trancada",
	tutorial_2_2: "Use o terminal para abrir a porta",
	tutorial_2_3: "(mova contra ele para operar)",
	tutorial_2_4: "Ande em diagonal aqui",
	tutorial_2_5: "Também pode se mover",
	tutorial_2_6: "usando o mouse.",
	tutorial_3_1: "Pegue uma arma na caixa",
	tutorial_3_2: "Mate os inimigos na outra sala",
	tutorial_3_3: "SHIFT + direção para atirar, ou SHIFT + click",
	tutorial_3_5: "Espere com [x] ou [.] ou num [0] e [5]",
	tutorial_3_7: "Projéteis movem 1 passo por vez, assim como você.",
	tutorial_3_9: "Pegue o canhão",
	tutorial_3_10: "Destrua os barris no corredor",
	tutorial_3_11: "Selecione arma com teclas 0-9, ou clicando com o mouse",
	tutorial_3_14: "Você gastou toda sua munição, pegue mais.",
	tutorial_3_16: "Destrua os barris no corredor",
	tutorial_4_1: "Use a chave para abrir a caixa",
	tutorial_4_3: "Esta porta está trancada",
	tutorial_4_4: "Ela só pode ser aberta com mísseis",
	tutorial_4_6: "Vá lá fora, mate os inimigos",
	tutorial_4_8: "Portais invocam inimigos continuamente",
	tutorial_4_9: "Destrua-os com canhão ou mísseis",
	tutorial_4_10: "Parabéns!",
	tutorial_4_11: "Você terminou o tutorial",
	tutorial_4_12: "Volte para o menu principal para iniciar um novo jogo.",
};
